import { AccountDetail, AccountLoadParameters } from '../models/account';
import { SimManagementError } from '../models/Errors';
import {
  CLEAR_SELECTED_ACCOUNT,
  ENSURE_SELECTED_ACCOUNT,
  LOAD_SELECTED_ACCOUNT,
  LOAD_SELECTED_ACCOUNT_FAILURE,
  LOAD_SELECTED_ACCOUNT_SUCCESS,
} from './actionTypes';
import { Action } from './commonActions';

/**
 * Action which loads the selected account from the server.
 * @param value The account details.
 */
export function clearSelectedAccount(): Action<AccountLoadParameters> {
  return {
    type: CLEAR_SELECTED_ACCOUNT,
  };
}

/**
 * Action which ensures that the selected account is loaded and will fetch from server if it is not.
 * @param value The account details.
 */
export function ensureSelectedAccount(value: AccountLoadParameters): Action<AccountLoadParameters> {
  return {
    type: ENSURE_SELECTED_ACCOUNT,
    payload: value,
  };
}

/**
 * Action which loads the selected account from the server.
 * @param value The account details.
 */
export function loadSelectedAccount(value: AccountLoadParameters): Action<AccountLoadParameters> {
  return {
    type: LOAD_SELECTED_ACCOUNT,
    payload: value,
  };
}

/**
 * Action which handles when the selected account is successfully loaded.
 * @param account The account.
 */
export function loadSelectedAccountSuccess(account: AccountDetail) {
  return {
    type: LOAD_SELECTED_ACCOUNT_SUCCESS,
    payload: account,
  };
}

/**
 * Action which handles when there is a failure to load the selected account.
 * @param id The account identifier.
 * @param error The error.
 */
export function loadSelectedAccountFailure(id: number, error: SimManagementError) {
  return {
    error: true,
    type: LOAD_SELECTED_ACCOUNT_FAILURE,
    payload: error,
    meta: id,
  };
}
